import { loader } from "../../utils/assetLoader";
import { spriteSize } from "../../utils/assets";
import { settings, returnPlatformType } from "../config";

const bgFoliage = [
    "BG_tree-1", "BG_tree-2", "BG_tree-3",
    "BG_grass-1"
];

const bgMountains = [
    "BG_mountain-1", "BG_mountain-2",
];

let lastFoliage = "BG_grass-1";
class Cosmetics {
    constructor(engine, app, config, levelLayout, prevLength = 0) {
        this.engine = engine;
        this.app = app;
        this.config = config;
        this.levelLayout = levelLayout;
        this.prevLength = prevLength;
        
        this.bgSegments = {
            container: new PIXI.Container(),
            count: -1,
        }
        
        this.bgElements = {
            foliage: {
                container: new PIXI.Container(),
                lastPos: 0,
            },
            mountain: {
                container: new PIXI.Container(),
                lastPos: 0,
            },
        }

        this.app.stage.addChild(this.bgSegments.container);
        this.app.stage.addChild(this.bgElements.mountain.container);
        this.app.stage.addChild(this.bgElements.foliage.container);
    }
    
    create() {
        console.log("create cosmetics");
        let xZero = this.prevLength;
        let xPosition = this.prevLength;
        const groundY = this.config.height - settings.groundHeight;
        
        const bgHeight = 300;
        this.bgSegments.count = -1;
        this.bgSegments.container.x = 0;
        this.bgSegments.container.y = this.config.height + bgHeight;

        this.bgElements.foliage.lastPos = xZero;
        this.bgElements.foliage.container.x = 0;
        this.bgElements.foliage.container.y = this.config.height + bgHeight - 572;

        this.bgElements.mountain.lastPos = xZero;
        this.bgElements.mountain.container.x = 0;
        this.bgElements.mountain.container.y = this.config.height + bgHeight - 572;
        this.checkBgTiles(xZero);


        // Create level elements based on the layout
        for (const section of this.levelLayout) {
            if(section.name == "gap") {
                this.checkBgTiles(xPosition, settings.gapWidth);
                xPosition += settings.gapWidth;
            } else if (returnPlatformType(section.name) === "hazard") {
                console.log(data.width);
                xPosition += data.width;
            } else if (!section.force) {
                let platformData = this.getPlatformData(section);
                
                // Background assets
                this.checkBgTiles(xPosition, platformData.width);

                // Cosmetic assets
                if(section.cosmetics) {
                    const container = new PIXI.Container();
                    container.x = xPosition;
                    container.y = groundY - platformData.height;
                    this.app.stage.addChild(container);
                    section.cosmetics.forEach(cosmetic => {
                        let tile = this.makeCosmetic(cosmetic.name, cosmetic.x);
                        container.addChild(tile);
                    });
                }
                xPosition += platformData.width;
            }
        }
        
        this.levelWidth = xPosition;

        return {
            levelWidth: this.levelWidth
        };
    }


    checkBgTiles(xPosition, nextWidth) {
        // let [bgWidth, bgHeight] = [loader.SpriteSize("BG_ground").x, loader.SpriteSize("BG_ground").y]
        // let newSegCount = Math.floor((xPosition + nextWidth) / bgWidth)
        // // console.log(newLength, bgWidth, newSegments);

        // if(newSegCount > this.bgSegments.count) {
        //     this.bgSegments.count++;
        //     let bgTile = this.makeCosmetic("BG_ground", this.prevLength + bgWidth * this.bgSegments.count);
        //     this.bgSegments.container.addChild(bgTile);
        // }

        // this.createBgElements(xPosition);
    }

    makeCosmetic(name, xPos) {
        const tile = loader.Sprite(name);
        tile.position.set(xPos, -tile.height);
        return tile;
    }

    getPlatformData(platform) {
        const type = returnPlatformType(platform.name).type;
        let [width, height] = [loader.SpriteSize(platform.name).x,  platform.height];
        if(platform.name.includes("ground")) {
            const offset = settings.groundPlatformsOffset;
            width += offset * 2;
        }

        return {width, height};
    }

    createBgElements(xPosition) {
        do {
            // Mountains
            const spawnMountain = Math.random() < 0.5;
            if(spawnMountain) {
                let name = bgMountains[Math.floor( Math.random() * bgMountains.length )]
                let elem = this.makeCosmetic(name, this.bgElements.mountain.lastPos);
                
                
                this.bgElements.mountain.lastPos += elem.width + 100;
                this.bgElements.mountain.container.addChild(elem);
                this.bgElements.mountain.container.addChild(elem);
            } else {
                const randPadding = Math.random() * 125 + 75;
                this.bgElements.mountain.lastPos += randPadding;
            }

            // Foliage
            const spawnFoliage = Math.random() < 0.4;
            if(spawnFoliage) {
                let name;
                do {
                    name = bgFoliage[Math.floor( Math.random() * bgFoliage.length )]
                    // if(lastFoliage === name) console.log(name);
                } while(lastFoliage === name)
                lastFoliage = name;
                    
                let elem = this.makeCosmetic(name, this.bgElements.foliage.lastPos);
                this.bgElements.foliage.lastPos += elem.width;
                this.bgElements.foliage.container.addChild(elem);
            } else {
                const randPadding = Math.random() * 75 + 25;
                this.bgElements.foliage.lastPos += randPadding;
            }

        } while(
            this.bgElements.foliage.lastPos < xPosition &&
            this.bgElements.mountain.lastPos < xPosition
        )
    }

}

export default Cosmetics;

